import React from 'react';

// styles
import './Footer.css';



const Footer = () => {
	
	
	return (
		<footer>
			<p>
				Marcus Vinícius Richa - Web Developer
			</p>
		</footer>
	);
};



export default Footer;



